<template>
	<R3Div v-if="props.visible" class="w-full">
		<Dropdown ref="dropDownRef" v-model="selectedValue" :disabled="!isEnabled" :pt="dropdown.style"
			:options="props.options" :option-label="props.optionLabel" :option-value="props.optionValue"
			:append-to="props.appendTo" class="w-full md:w-14rem" @blur="$emit('blur')" />
		<!--{{ 'selectedValue = ' + selectedValue }}<br>
		{{ 'dropdown.inputValue = ' + dropdown.inputValue }}<br>
		{{ 'props.modelValue = ' + props.modelValue }}-->
	</R3Div>
</template>

<script lang="ts" setup>
	import { ref, watch, onMounted, onBeforeMount, markRaw, nextTick } from 'vue';
	import { R3DropdownClass } from "~/classes/base/R3Dropdown.classes";
	import { useExposeProperties } from "#imports";
	import { normalizeDropdownValue } from "./R3DropDown/dropdownValue";
	// import Dropdown from 'primevue/dropdown';
	// import { R3Dropdown } from '~/stories/R3/components/dropdown/teste.stories';



	const props = withDefaults(defineProps<{
		enabled?: boolean;
		visible?: boolean;
		default?: ModelType;
		modelValue: ModelType;
		options: unknown[];
		datafinder?: boolean;
		optionLabel?: string;
		optionValue?: string;
		passthrough?: object;
		appendTo?: string | HTMLElement;
	}>(), {
		passthrough: () => markRaw({}),
		datafinder: false,
		optionLabel: "",
		optionValue: "",
		default: "",
		enabled: true,
		visible: true,
		appendTo: 'self'
	});

	const emits = defineEmits(["update:modelValue", "blur"]);


	function normalizeValue(value: ModelType) {
		return normalizeDropdownValue(value, props.default);
	}

	const selectedValue = ref(normalizeValue(props.modelValue));

	const dropdown = new R3DropdownClass(props.modelValue);

	const isEnabled = computed(() => dropdown.enabled);

	watch(() => props.enabled, (newValue) => {
		if (newValue !== undefined) {
			dropdown.enabled = newValue;
		}
	}, { immediate: true });

	watch(() => props.visible, (newValue) => {
		if (newValue !== undefined) {
			dropdown.visible = newValue;
		}
	}, { immediate: true });

	// Adiciona um watch para reagir quando props.options for preenchido/atualizado
	/*watch(
		() => props.options,
		(newOptions) => {
			if (props.datafinder && props.optionValue !== undefined && props.modelValue !== undefined) {
				dropdown.inputValue = newOptions.find(option => option.default);
				console.log('Atualizado via watch:', dropdown.inputValue);
			}
		},
		{ immediate: true, deep: true }
	);*/



	type ModelType = string | object | null;

	interface FocusParams {
		limparCampo?: boolean;
	}




	watch(() => props.modelValue, (value) => {
		const normalizedValue = normalizeValue(value);
		if (normalizedValue !== selectedValue.value) {
			selectedValue.value = normalizedValue;
		}
	}, { immediate: true });

	watch(selectedValue, (value: typeof props.modelValue) => {
		if (value !== props.modelValue) {
			emits('update:modelValue', value);
		}
		dropdown.inputValue = value;
	}, { immediate: true });




	/*watch(
		() => dropdown.inputValue,
		(value) => { emits("update:modelValue", value) }
	);*/

	// const selectedValue = computed({
	// 	get: () => props.modelValue,
	// 	set: (value) => emits('update:modelValue', value === undefined ? null : value)
	// });
	const dropDownRef = useTemplateRef("dropDownRef");
	const isOpening = ref(false);

	async function setFocus({ limparCampo = false }: FocusParams = {}) {
		if (isOpening.value) return;
		isOpening.value = true;

		if (limparCampo) {
			selectedValue.value = '';
		}

		try {
			await nextTick();
			dropDownRef.value?.show();
		} finally {
			isOpening.value = false;
		}
	}

	onBeforeMount(() => {
		if (props.default && props.default !== "") {
			dropdown.inputValue = props.default;
		}
	})

	onMounted(() => {
		dropdown.elemento.value = dropDownRef.value as unknown as ComponentPublicInstance | null;
	})


	// function onUpdateModelValue(value: ModelType) {
	// 	dropdown.inputValue = value;
	// }

	type exposeType = {
	} & typeof dropdown

	const expose = {

	} as exposeType;


	useExposeProperties(expose, dropdown)
	defineExpose(expose);


	// defineExpose({
	// 	selectedValue,
	// 	setFocus,
	// 	dropDownRef
	// });



	// defineExpose({
	// 	selectedValue,
	// 	setFocus,
	// 	dropDownRef
	// });


</script>

<style></style>
